import Vue from 'vue'
import App from './App.vue'
import {
  Button, 
  Select, 
  Header,
  Aside,
  Main,
  Footer,
  Container,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Switch,
  Option,
  OptionGroup,
  ButtonGroup,
  Table,
  TableColumn,
  Form,
  FormItem,
  TimePicker,
  DatePicker,
  Col,
  Submenu,
  Menu,
  MenuItem,
  MenuItemGroup,
  BreadcrumbItem,
  Breadcrumb,
  Pagination,
  Tooltip,
  Tag,
  Alert,
  Row,
  Dialog,
  MessageBox,
  Message,
  Divider,
  Tree,
  Card,
  Carousel,
  CarouselItem,
  Tabs,
  TabPane,
  Steps,
  Step,
  Cascader,
  Upload,
  Loading,
  Rate,
  Popover,
  Popconfirm,
  Drawer,
  Empty,
  Link,
} from 'element-ui';
import router from './router';
import './style/index.scss'
import './style/element-variables.scss'
import 'amfe-flexible'
// import 'element-ui/lib/theme-chalk/index.css';
import './style/iconfont.js'
import store from './store/store.js'
import permission from '@/utils/permission' 
import * as echarts from 'echarts';

Vue.use(permission)

Vue.config.productionTip = false
Vue.prototype.$echarts = echarts

Vue.use(Button)
Vue.use(Select)
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Footer);
Vue.use(Container)
Vue.use(Input);
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(RadioButton);
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Switch);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(ButtonGroup);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Form);
Vue.use(TimePicker);
Vue.use(DatePicker);
Vue.use(FormItem);
Vue.use(Col)
Vue.use(Submenu)
Vue.use(Menu)
Vue.use(MenuItem);
Vue.use(MenuItemGroup)
Vue.use(BreadcrumbItem)
Vue.use(Breadcrumb)
Vue.use(Pagination)
Vue.use(Tooltip)
Vue.use(Tag)
Vue.use(Alert)
Vue.use(Row)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(Card)
Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Cascader);
Vue.use(Upload);
Vue.use(Divider)
Vue.use(Rate)
Vue.use(Popover)
Vue.use(Popconfirm)
Vue.use(InputNumber)
Vue.use(Drawer)
Vue.use(Empty)
Vue.use(Link)
Vue.use(Loading.directive);
// Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.$prompt = MessageBox.prompt;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
